"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = require("react");
var PropTypes = require("prop-types");
var classnames_1 = require("classnames");
var Portal_1 = require("../base/Portal");
var AppBar = /** @class */ (function (_super) {
    tslib_1.__extends(AppBar, _super);
    function AppBar(props, context) {
        var _this = _super.call(this, props, context) || this;
        _this.onWindowScroll = function (e) {
            var _a = _this.props, enableSticky = _a.enableSticky, scrollStartAt = _a.scrollStartAt;
            if (!enableSticky) {
                return;
            }
            _this.setScrolled(window.pageYOffset >= scrollStartAt);
        };
        _this.setRef = function (el) {
            _this.$el = el;
        };
        _this.$el = null;
        _this.state = { isScrolled: false };
        return _this;
    }
    AppBar.prototype.componentDidMount = function () {
        window.addEventListener("scroll", this.onWindowScroll, { passive: true });
        if (this.props.enableSticky) {
            this.pushLayoutTop();
        }
    };
    AppBar.prototype.componentWillUnmount = function () {
        window.removeEventListener("scroll", this.onWindowScroll, { passive: true });
        if (this.props.enableSticky) {
            this.pullLayoutUp();
        }
    };
    AppBar.prototype.pushLayoutTop = function () {
        var pushAppContainerFromTop = this.context.pushAppContainerFromTop;
        if (pushAppContainerFromTop) {
            pushAppContainerFromTop(this.$el.offsetHeight);
        }
    };
    AppBar.prototype.pullLayoutUp = function () {
        var pushAppContainerFromTop = this.context.pushAppContainerFromTop;
        if (pushAppContainerFromTop) {
            pushAppContainerFromTop(0);
        }
    };
    AppBar.prototype.setScrolled = function (scrolled) {
        var isScrolled = this.state.isScrolled;
        if (isScrolled !== scrolled) {
            this.setState({ isScrolled: scrolled });
        }
    };
    AppBar.prototype.render = function () {
        var _a;
        var _b = this.props, children = _b.children, theme = _b.theme, className = _b.className, enableSticky = _b.enableSticky, useGlassTexture = _b.useGlassTexture, onMouseOver = _b.onMouseOver, onMouseLeave = _b.onMouseLeave, others = tslib_1.__rest(_b, ["children", "theme", "className", "enableSticky", "useGlassTexture", "onMouseOver", "onMouseLeave"]);
        var isScrolled = this.state.isScrolled;
        var classes = classnames_1.default(theme["app-bar"], className, (_a = {},
            _a[theme.sticky] = enableSticky,
            _a[theme.scrolled] = isScrolled,
            _a[theme.glass] = useGlassTexture,
            _a));
        return (React.createElement(Portal_1.default, null,
            React.createElement("header", { onMouseLeave: onMouseLeave, onMouseOver: onMouseOver, className: classes, ref: this.setRef }, children)));
    };
    AppBar.defaultProps = {
        enableSticky: true,
        scrollStartAt: 100,
        useGlassTexture: true
    };
    AppBar.contextTypes = {
        disablePageScroll: PropTypes.func,
        enablePageScroll: PropTypes.func,
        pushAppContainerFromTop: PropTypes.func
    };
    return AppBar;
}(React.Component));
exports.default = AppBar;
